import type { EmailRecipient } from "src/api/preApproval/types";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email.trim());
}

export function createRecipient(
  email: string,
  group: "borrower" | "dealer",
): EmailRecipient {
  const normalized = email.trim().toLowerCase();
  return {
    id: `${group}:${normalized}`,
    email: normalized,
    label: group === "borrower" ? "Borrower" : "Dealer",
    group,
  };
}

export function splitRecipientsByGroup(recipients: EmailRecipient[]) {
  const valid = recipients.filter((recipient) => isValidEmail(recipient.email));
  return {
    borrowerRecipients: valid.filter(
      (recipient) => recipient.group === "borrower",
    ),
    dealerRecipients: valid.filter((recipient) => recipient.group === "dealer"),
  };
}
